"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _react = _interopRequireDefault(require("react"));
var _EventAvailable = _interopRequireDefault(require("@kyruus/react-ikons/EventAvailable"));
var _MobileTeleHealth = _interopRequireDefault(require("@kyruus/react-ikons/MobileTeleHealth"));
var _Phone = _interopRequireDefault(require("@kyruus/react-ikons/Phone"));
var _Schedule = _interopRequireDefault(require("@kyruus/react-ikons/Schedule"));
var _globals = require("../../lib/constants/globals");
var _provider = require("../../lib/provider");
var _messages = _interopRequireDefault(require("../../lib/constants/messages"));
var _infoLine = _interopRequireDefault(require("../InfoLine/info-line"));
const BookingInfo = _ref => {
  var _context;
  let {
    provider,
    shouldDisplayAvailability,
    slotsStatus
  } = _ref;
  const providerHasBookOnline = !!provider.book_online_url;
  const visitType = (0, _provider.getVisitType)(provider);
  const isVirtualProvider = (0, _provider.isVirtualProvider)(provider);
  const providerWillRenderAvailTiles = provider.locations ? (0, _filter.default)(_context = provider.locations).call(_context, _ref2 => {
    let {
      slots = false
    } = _ref2;
    return slots;
  }).length > 0 : false;

  // whether or not to show "available in X days"
  let showAvailabilityDensityBest = true;
  if (shouldDisplayAvailability) {
    if (slotsStatus !== _globals.SLOTS_SUCCESS_STATUS) {
      // if avail tiles are enabled, but slots have not been fetched, suppress the text.
      // When avail tiles are active, we should only display the text when there is no
      // availability from slots
      showAvailabilityDensityBest = false;
    }
    if (providerWillRenderAvailTiles) {
      // if we have slots data for avail tiles, suppress the text
      showAvailabilityDensityBest = false;
    }
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, providerHasBookOnline && /*#__PURE__*/_react.default.createElement(_infoLine.default, {
    Icon: _EventAvailable.default,
    infoMessage: _messages.default.onlinebooking
  }), provider.availability_density_best && showAvailabilityDensityBest && /*#__PURE__*/_react.default.createElement(_infoLine.default, {
    Icon: _Schedule.default,
    infoMessage: _messages.default.availability,
    values: {
      days: provider.availability_density_best
    },
    afterText: "*"
  }), isVirtualProvider && /*#__PURE__*/_react.default.createElement(_infoLine.default, {
    Icon: _MobileTeleHealth.default,
    infoMessage: _messages.default.appointmentVideoTitle
  }), visitType[_globals.VISIT_TYPES.PHONE] && /*#__PURE__*/_react.default.createElement(_infoLine.default, {
    Icon: _Phone.default,
    infoMessage: _messages.default.appointmentPhoneTitle
  }));
};
var _default = exports.default = BookingInfo;
BookingInfo.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "BookingInfo"
};